// extracted by mini-css-extract-plugin
export default {"container":"Forbidden_container__Kthk6","item":"Forbidden_item__cA8j2"};